import React from 'react';

const Timeline = () => {
    return (
        <div id='timeline' className='text-center' style={{ padding: '150px 0' }}>
            <h2 data-aos="flip-up" className='timeline_header'>Timeline</h2>
            <p className='timeline_para'>
                Be a O2Club member and start earning Tokens
            </p>
            <div className='d-flex justify-content-center'>
                <div className='d-none d-md-block'>
                    <div className='d-flex justify-content-center flex-wrap' style={{ marginTop: '80px' }}>
                        <div className='' style={{ margin: '0 40px' }}>
                            <img src="/img/Group1.png" alt="" />
                        </div>
                        <div className='mt-5 mt-md-0' style={{ margin: '0 60px' }}>
                            <img src="/img/Group2.png" alt="" />
                        </div>
                        <div className='mt-5 mt-md-0' style={{ margin: '0 40px' }}>
                            <img src="/img/Group3.png" alt="" />
                        </div>
                        <div className='mt-5 mt-md-0' style={{ margin: '0 40px' }}>
                            <img src="/img/Group4.png" alt="" />
                        </div>
                        <div className='mt-5 mt-md-0' style={{ margin: '0 40px' }}>
                            <img src="/img/Group5.png" alt="" />
                        </div>
                        <div className='mt-5 mt-md-0' style={{ margin: '0 40px' }}>
                            <img src="/img/Group6.png" alt="" />
                        </div>
                    </div>
                </div>
                <div className='d-block d-md-none'>
                    <div className='d-flex justify-content-center'>
                        <div className='row mt-5'>
                            <div className='col-md-2'>
                                <img src="/img/Group1.png" alt="" />
                            </div>
                            <div className='col-md-2 mt-5 mt-md-0' >
                                <img src="/img/Group2.png" alt="" />
                            </div>
                            <div className=' col-md-2 mt-5 mt-md-0' >
                                <img src="/img/Group3.png" alt="" />
                            </div>
                            <div className=' col-md-2 mt-5 mt-md-0' >
                                <img src="/img/Group4.png" alt="" />
                            </div>
                            <div className=' col-md-2 mt-5 mt-md-0' >
                                <img src="/img/Group5.png" alt="" />
                            </div>
                            <div className='col-md-2 mt-5 mt-md-0' >
                                <img src="/img/Group6.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Timeline;